import {
  RecentSearch,
  getQueryKey,
  newRecentSearch,
  STORAGE_KEY,
  addSearchSignature,
  getSignature,
  getManySignature,
  setSignature,
  forgetSignature,
  getAllSignature
} from './common';

const getOldestSearch = (items: RecentSearch[]): RecentSearch => {
  const search = items.reduce((a, b) => {
    return a.date < b.date ? a : b;
  });
  return search;
};

const getAllSearchKeys = (userId: string): string[] => {
  return Object.keys(localStorage).filter(key => {
    return key.includes(`${STORAGE_KEY}_${userId}`);
  });
};

export const get: getSignature = (userId: string, query: string): RecentSearch | boolean => {
  try {
    const value = localStorage.getItem(getQueryKey(userId, query));
    if (value !== null) {
      return JSON.parse(value);
    }
    return false;
  } catch (e) {
    return false;
  }
};

export const set: setSignature = (
  userId: string,
  query: string,
  params: any
): RecentSearch | boolean => {
  try {
    const newSearch = newRecentSearch(userId, query, params);
    localStorage.setItem(getQueryKey(userId, query), JSON.stringify(newSearch));
    return newSearch;
  } catch (e) {
    return false;
  }
};

export const forget: forgetSignature = (userId: string, queryKey: string): boolean => {
  try {
    localStorage.removeItem(getQueryKey(userId, queryKey));
  } catch (e) {
    return false;
  }
  return true;
};

export const getManySearchesByKey: getManySignature = (keys: string[]): RecentSearch[] => {
  let all: any[] = [];
  try {
    all = keys.reduce((acc, key) => acc.concat([[key, localStorage.getItem(key)]]), []);
  } catch (e) {
    return [];
  }
  return all.map(search => {
    return JSON.parse(search[1]);
  });
};

export const getAllRecentSearches: getAllSignature = (userId: string) => {
  try {
    const storageKeys = getAllSearchKeys(userId);
    if (storageKeys.length) return getManySearchesByKey(storageKeys);
  } catch (e) {
    return [];
  }

  return [];
};

export const addSearch: addSearchSignature = (
  userId: string,
  searchQuery: string,
  searchParams: any
) => {
  const existing = get(userId, searchQuery);
  if (existing) {
    return set(userId, searchQuery, searchParams);
  }
  const storedSearches: RecentSearch[] = getAllRecentSearches(userId);

  // if there are 5 or more items already stored, lets delete the oldest one
  if (storedSearches.length >= 5) {
    const oldest = getOldestSearch(storedSearches);

    try {
      forget(userId, oldest.searchQuery);
    } catch (e) {
      return false;
    }
  }

  try {
    return set(userId, searchQuery, searchParams);
  } catch (e) {
    return false;
  }
};
